import { Injectable } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

@Injectable({
    providedIn: 'root'
})
export class PrimeNGCorrectionService {

    constructor() {
        this.init();

    }


    init() {
        // this.installOverlayPanelFix();
    }
    private installOverlayPanelFix() {
        const onAlignSource: Function = OverlayPanel.prototype.align;
        OverlayPanel.prototype.align = function (this: OverlayPanel) {
            const _this = this;
            if (_this.container != null && _this.target != null) {
                onAlignSource.call(_this);
            }
        };

        const onBindDocumentClickListenerSource: Function = OverlayPanel.prototype.bindDocumentClickListener;
        OverlayPanel.prototype.bindDocumentClickListener = function (this: OverlayPanel) {
            const _this = this;
            if (_this.container != null && _this.target != null) {
                onBindDocumentClickListenerSource.call(_this);
            }
        };

        OverlayPanel.prototype.hide = function (this: OverlayPanel) {
            const _this = this;
            _this.render = false;
            _this.overlayVisible = false;
        };


        OverlayPanel.prototype.onAnimationStart = function (this: OverlayPanel, event: any) {
            if (event.toState === 'open') {
                setTimeout(() => {
                  this.container = event.element;
                  this.onShow.emit(null);
                  this.appendContainer();
                  this.align();
                  this.bindDocumentClickListener();
                  this.bindDocumentResizeListener();
                  this.bindScrollListener();

                  if (this.focusOnShow) {
                    this.focus();
                  }
                });
              }


            // const _this = this;
            // onAnimationEndSource.call(_this, event);
            // if (event.toState === 'close') {
            //     _this.render = true;
            //     (_this as any).cd.detectChanges();
            // }
        };

        const onAnimationEndSource: Function = OverlayPanel.prototype.onAnimationEnd;
        OverlayPanel.prototype.onAnimationEnd = function (this: OverlayPanel, event: any) {
            const _this = this;
            onAnimationEndSource.call(_this, event);
            if (event.toState === 'close') {
                _this.render = true;
                // (_this as any).cd.detectChanges();
            }
        };


    }
}
